// Components
import AlertMessage from "../../mavin/components/alert-message/AlertMessage";

// No Chart Data Present Message
export function NoChartDataMessage({
  message = "",
  containerClassName = "",
  className = "",
}) {
  return (
    <div className={containerClassName}>
      <AlertMessage
        isLoading={false}
        className={`justify-content-center m-5 ${className}`}
        textMessage={message}
      />
    </div>
  );
}
